import _regenerator from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { mapGetters, mapMutations } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
// import Hamburger from '@/components/Hamburger'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'

export default {
  components: {
    Breadcrumb: Breadcrumb
    // Hamburger
    // Screenfull,
    // SizeSelect,
    // Search
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'device'])),
  methods: _objectSpread(_objectSpread({}, mapMutations({
    SET_TOKEN: 'user/SET_TOKEN'
  })), {}, {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.SET_TOKEN('');
              _this.$router.push("/login?redirect=".concat(_this.$route.fullPath));
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  })
};